<template>
    <div class="widget-contents DialogContent">
        <div class="widget-contents__inner DialogContentInner">
            <form
                :action="$laraRoute('widget.personalise')"
                method="POST"
                @submit.prevent="handleForm"
                id="widget-form"
                enctype="multipart/form-data"
                novalidate
            >
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="nickname"
                        class="col-md-3"
                    ><span v-translate>Avatar Name</span></label>
                    <div class="col-md-8 col-lg-7">
                        <Input
                            :rule="'nickname'"
                            name="nickname"
                            errorType="nickname"
                            model="user.nickname"
                            module="Widget"
                            :required="true"
                            :maxlength="40"
                        />
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="avatar"
                        class="col-md-3"
                    ><span v-translate>Profile Picture</span> <span
                            class="label-inner"
                            v-translate
                        >(Optional)</span></label>
                    <div class="col-md-8 col-lg-7">
                        <file-upload
                            :existing-file="this.user.profile_pic_url"
                            id="avatar"
                        ></file-upload>
                    </div>
                </div>
                <div class="form-group form-row justify-content-center">
                    <div class="col-12 col-md-10 text-right">
                        <LoaderedButton
                            type="submit"
                            btnClasses="btn btn-primary"
                            :content="'Save' | translate"
                        />
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <flash-message></flash-message>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapMutations, mapState } from 'vuex';
import Input from '@C/Forms/Input';
import FileUpload from '@C/FileUpload';
import LoaderedButton from '@C/LoaderedButton';
import widgetMixin from '@M/widgets/topLevel';
import validator from '@M/validationWrapper';
import FlashMessage from '@C/FlashMessage';

const state = {
    ...mapState('Widget', ['user'])
};

const fields = {
    ...mapFields('Widget', [
        'user.nickname'
    ])
};

const actions = {
    ...mapActions('Widget', ['updatePersonalisation']),
};

export default {
    name: 'Personalise',
    components: {
        Input,
        FileUpload,
        LoaderedButton,
        FlashMessage
    },
    mixins: [widgetMixin, validator],
    computed: {
        ...state,
        ...fields
    },
    methods: {
        ...actions,
        formHandler() {
            this.updatePersonalisation();
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Personalise.vue